import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoaderService } from '../loader.service';
import {MatSnackBar} from '@angular/material/snack-bar';

export const ApiErrorService: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const loader = inject(LoaderService)
  const _snackBar = inject(MatSnackBar);
  return next(req).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = 'An unknown error occurred!';

        if (error.error instanceof ErrorEvent) {
          // Client-side error
          errorMessage = `Client Error: ${error.error.message}`;
        } else {
          // Server-side error
          switch (error.status) {
            case 400:
              errorMessage = 'Bad Request. Please check your input.';
              break;
            case 401:
              errorMessage = 'Unauthorized. Please log in.';
              break;
            case 403:
              errorMessage = 'Forbidden. You do not have permission.';
              break;
            case 404:
              errorMessage = 'Not Found. The requested resource does not exist.';
              break;
            case 500:
              errorMessage = 'Internal Server Error. Try again later.';
              break;
            default:
              errorMessage = `API Error (${error.status}): ${error.message}`;
          }
        }

        console.error('API Error:', errorMessage);
        loader.hide();
        //alert(errorMessage); // Replace with toast/snackbar if needed
        _snackBar.open(errorMessage, "", {
          duration: 5000, // Duration in milliseconds
          panelClass: ['custom-snackbar'],
          verticalPosition: "top", // Optional: "top" or "bottom"
          horizontalPosition: "center" // Optional: "start", "center", "end", "left", "right"
        });

        return throwError(() => new Error(errorMessage));
      })
    );
  }

